import { ArrowRight } from "../assets";

const Reserve = () => {
  return (
    <>
      <div className="md:p-2 lg:p-2 mt-4 md:mt-10 lg:mt-10 w-full md:border-[1px] md:border-solid md:border-neutral-500 md:rounded-full  lg:border-[1px] lg:border-solid lg:border-neutral-500 lg:rounded-full flex flex-col gap-3 md:flex-row lg:flex-row items-center justify-between lg:h-auto lg:w-[679px] m-auto">
        <a
          href="https://app.buymejollof.com/login"
          target="_blank"
          rel="noreferrer"
          className="bg-mainYellow bold-font py-4 px-8 w-full gap-2 rounded-full flex justify-center "
        >
          Join as a creator
          <ArrowRight />
        </a>
      </div>
    </>
  );
};

export default Reserve;
